import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { openDeleteDraftModal } from 'app/dispatcher/modalDispatcher';
import { setEditOpinionDraftId } from 'app/dispatcher/draftDispatcher';

const useDraftOpinionMenu = ({ opinion }) => {
  const { id } = opinion;

  const router = useRouter();
  const dispatch = useDispatch();

  const menuOption = [
    {
      title: 'Edit',
      key: 'edit',
      onClick: () => {
        window.scrollTo(0, 0);
        dispatch(setEditOpinionDraftId(id));
        router.push({
          pathname: '/post-opinion',
        });
      },
    },
    {
      title: 'Delete',
      key: 'delete',
      onClick: () => {
        dispatch(openDeleteDraftModal({ id }));
      },
    },
  ];

  return menuOption;
};

export default useDraftOpinionMenu;
